import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';

import { BombBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { getBlockViewScale } from './FitWidthBlockSprite';

/*
    bomb block view
*/
export class BombBlockView extends Container {
  public readonly animation!: MovieClip;

  // init
  //-------------------------------------------------------------------------
  constructor(props: BombBlockProps) {
    // create base view
    super();

    this.animation = new MovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/power/bomb'),
      defaultAnimation: 'waterballoon_idle',
      scale: getBlockViewScale(88, props),
      fps: 40,
    });

    blockPositionView(this, props);
  }

  public static assets() {
    return [
      {
        url: getMatch2AssetPath('blocks/power/bomb'),
        loadMethod: MovieClip.animationLoader,
      },
    ];
  }
}
